import { axiosApi, basePath } from "./api";

// 删除仓库
export function deleteWarehouseInfo (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/warehouse/info/delete', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
};

// 更新仓库
export function updateWarehouseInfo (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/warehouse/info/update', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
};

// 新增仓库
export function insertWarehouseInfo (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/warehouse/info/insert', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
};

// 仓库列表
export function getWarehouseList(data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/warehouse/info/list', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
};